'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

// Avisa al contador propio (/api/visita) cada vez que se abre una página.
// Va con sendBeacon y en try/catch para que NUNCA bloquee ni demore la página.
export default function RegistroVisita() {
  const ruta = usePathname();

  useEffect(() => {
    try {
      if (/^\/verify\b/.test(ruta || '')) return; // el verificador tiene su propia bitácora
      const datos = JSON.stringify({
        p: ruta,
        r: document.referrer,
        q: window.location.search,
      });
      if (typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon('/api/visita', new Blob([datos], { type: 'application/json' }));
      } else {
        fetch('/api/visita', { method: 'POST', body: datos, keepalive: true }).catch(() => {});
      }
    } catch {
      // Silencioso a propósito.
    }
  }, [ruta]);

  return null;
}
